import { SlideshowCarousel } from 'theme';

// Only custom slideshows opt in. All navigation and animations remain Prestige's.
class DFSlideshow extends SlideshowCarousel {
  connectedCallback() {
    super.connectedCallback();
    this._dfAbort = new AbortController();
    const options = { signal: this._dfAbort.signal };
    this._dfObserver = new IntersectionObserver(() => this._dfSync(), { threshold: 0 });
    this._dfObserver.observe(this);
    this.addEventListener('carousel:settle', () => this._dfSync(), options);
    document.addEventListener('visibilitychange', () => this._dfSync(), options);
    window.matchMedia('(min-width: 700px)').addEventListener('change', () => this._dfSync(), options);
  }

  disconnectedCallback() {
    this._dfAbort?.abort();
    this._dfObserver?.disconnect();
    this._dfPause();
    super.disconnectedCallback();
  }

  _dfVisible() {
    const rect = this.getBoundingClientRect();
    return !document.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
  }

  _dfPause(except = null) {
    this.querySelectorAll('video-media').forEach(media => {
      if (media !== except) media.querySelector('video')?.pause();
    });
  }

  _dfActivate(slide) {
    if (!slide || !this._dfVisible()) { this._dfPause(); return; }
    const media = [...slide.querySelectorAll('video-media')].find(item => getComputedStyle(item).display !== 'none');
    this._dfPause(media);
    if (!media) return;
    const template = media.querySelector('template[data-df-slideshow-video]');
    if (template) {
      template.replaceWith(template.content.cloneNode(true));
      // Safari needs source selection restarted after mounting inert media.
      media.querySelector('video')?.load();
    }
    // Native play() catches NotAllowedError and exposes controls as a fallback.
    media.play();
  }

  _dfSync() { this._dfActivate(this.selectedCell); }

  createOnBecameVisibleAnimationControls(slide) {
    this._dfActivate(slide);
    return super.createOnBecameVisibleAnimationControls(slide);
  }

  createOnChangeAnimationControls(from, to, options) {
    // Native transitions see no video in an unvisited slide, so no source can
    // load before our explicit activation of the destination's visible format.
    const controls = super.createOnChangeAnimationControls(from, to, options);
    this._dfActivate(to);
    return controls;
  }
}

if (!customElements.get('df-slideshow-carousel')) {
  customElements.define('df-slideshow-carousel', DFSlideshow);
}
